// extracted by mini-css-extract-plugin
module.exports = {"backToTopWrapper":"ju","arrowUp":"jv","backToTopLink":"jw"};